import RightsRequestPage from "./RightsRequestPage"

export default RightsRequestPage
